import Service from '../abstract/service'

export default class Parametro extends Service {
  constructor() {
    super()
    this._empresaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    )
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
  }

  async getByEmpresa(empresa) {
    try {
      this._loading.setLoading(true, 'Buscando Parametros')
      const response = await this._empresaRef
        .doc(empresa)
        .collection('ParametrosEmpresa')
        .get()

      let parametros = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          parametros.push({
            empresa,
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(parametros)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async desativaSincronizacaoAntiga(parametro) {
    try {
      const response = await this._dataSyncRef.where('ativo', '==', true)
        .where('descricao', '==', parametro)
        .get()
      if (!response.empty) {
        const [doc] = response.docs
        const sincAntiga = await this._dataSyncRef.doc(doc.id)
        await sincAntiga.update({ ativo: false })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async criaSincronizacao(parametro, empresas) {
    try {
      this._loading.setLoading(true, 'Gerando Sincronização')
      let descricao = ''

      if (parametro == 'Parametro Consorcio') {
        descricao = 'ConsorcioParam'
      } else if (parametro == 'Parametro Leads') {
        descricao = 'LeadParam'
      } else if (parametro == 'Parametro Comissão') {
        descricao = 'ComissaoParam'
      } else if (parametro == 'Parametro Financiamento') {
        descricao = 'FinanParam'
      } else if (parametro == 'Parametro Financiamento Produto Forca') {
        descricao = 'FinanParamProdutoForca'
      }

      await this.desativaSincronizacaoAntiga(descricao)

      await this._dataSyncRef.doc().set({
        ativo: true,
        dataCriacao: new Date(),
        descricao,
        empresas
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updateParametro(parametro) {
    try {
      this._loading.setLoading(true, 'Atualizando Parametro')
      const response = await this._empresaRef
        .doc(parametro.empresa)
        .collection('ParametrosEmpresa')
        .doc(parametro.id)

      delete parametro.empresa
      delete parametro.id
      response.update({ ...parametro })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
